import React from 'react';
import styled from 'styled-components';

import Section from './SectionWrapper';

import {
	DisplayLarge,
	DisplaySmall,
	CalloutSm,
	BaseSmallHeading,
} from '@styled-components/Typography';

const QuoteWrapper = styled.blockquote`
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4rem; /* 64px */
	margin: 0 auto;

	${({ theme }) => theme.mediaQuery.breakpointMd} {
		max-width: ${({ smallQuote }) => !smallQuote && '60vw'};
	}
`;

const QuoteAuthor = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem; /* 16px */
	justify-content: center;
	align-items: center;

	img {
		width: 64px;
		height: 64px;
		border-radius: 50%;
	}

	.quote-author-details {
		display: flex;
		flex-direction: column;
		gap: 1rem; /* 8px */
	}
`;

const QuoteAuthorName = styled(BaseSmallHeading)`
	font-size: 2.2rem; /* 22px */
	font-style: normal;
	font-weight: 500;
	line-height: 125%; /* 27.5px */
	margin-bottom: 0;
`;

const SingleQuote = ({ content, smallQuote, ...props }) => {
	return (
		<div {...props}>
			<QuoteWrapper smallQuote={smallQuote}>
				{smallQuote ? (
					<DisplaySmall>&#8220;{content.quote.quote}&#8221;</DisplaySmall>
				) : (
					<DisplayLarge>&#8220;{content.quote.quote}&#8221;</DisplayLarge>
				)}

				<QuoteAuthor>
					{content.quoteAuthor.authorBioPhoto && (
						<img
							src={content.quoteAuthor.authorBioPhoto.file.url}
							alt={`Headshot photo for ${content.quoteAuthor.authorName}`}
						/>
					)}
					<div className="quote-author-details">
						<QuoteAuthorName>{content.quoteAuthor.authorName}</QuoteAuthorName>
						<CalloutSm>{content.quoteAuthor.authorJobTitle}</CalloutSm>
					</div>
				</QuoteAuthor>
			</QuoteWrapper>
		</div>
	);
};

export default SingleQuote;
